function isMobileDevice() {
  if (typeof navigator === "undefined") return false;

  return /Android|iPhone|iPad|iPod|Mobi/i.test(navigator.userAgent);
}

function downloadBlobViaAnchor(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();

  window.setTimeout(() => {
    URL.revokeObjectURL(url);
    anchor.remove();
  }, 1000);
}

async function sharePdfFile(blob, filename, title) {
  const file = new File([blob], filename, { type: "application/pdf" });
  const shareData = { files: [file], title: title || filename };

  if (!navigator.share || !navigator.canShare?.(shareData)) {
    return false;
  }

  await navigator.share(shareData);
  return true;
}

async function openMobilePdfPreview(pdfBlob, filename, deliveryTitle) {
  const { openPdfPreview } = await import("./pdfPreviewHost");

  return openPdfPreview({
    blob: pdfBlob,
    title: deliveryTitle,
    filename,
    onShare: async () => {
      try {
        const shared = await sharePdfFile(pdfBlob, filename, deliveryTitle);
        if (!shared) {
          downloadBlobViaAnchor(pdfBlob, filename);
        }
      } catch (error) {
        if (error?.name !== "AbortError") {
          throw error;
        }
      }
    },
    onDownload: () => {
      downloadBlobViaAnchor(pdfBlob, filename);
    },
  });
}

/**
 * Deliver a generated PDF blob to the user.
 * Mobile: in-app responsive preview with share/download actions
 * Desktop: standard file download
 */
export async function deliverPdfBlob(blob, filename, { title } = {}) {
  if (!(blob instanceof Blob)) {
    throw new Error("A PDF Blob is required");
  }

  const pdfBlob =
    blob.type === "application/pdf"
      ? blob
      : new Blob([blob], { type: "application/pdf" });

  const deliveryTitle = title || filename;

  if (isMobileDevice()) {
    const previewResult = await openMobilePdfPreview(
      pdfBlob,
      filename,
      deliveryTitle,
    );
    return { method: "preview", ...previewResult };
  }

  downloadBlobViaAnchor(pdfBlob, filename);
  return { method: "download" };
}
